import StartRecoveryForm from './StartRecoveryForm';

export default StartRecoveryForm;
